export interface CheckShiftConflictsDto {
  contractorId: string;
  shiftDate: string;
  startTime: string;
  endTime: string;
}
